import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useStore } from "vuex";
import figureFormatter from "@/services/utils/figureFormatter";
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}
const pdfPrinter = () => {
    const store = useStore();
    const {commaFormat} = figureFormatter();
    const {getHeader, getFooter} = pdfHeaderFooter();

    const userName = store.state.user.user.name;

    const exportToPDF = (company, grossComponentPayHead, otherEarningPayHead, deductionPayHeadPayHead, payrollData, summaryData, payrollStatementData) => {
        var doc = {
            pageSize: 'A4',
            pageMargins: [10, 100, 10, 80],
            pageOrientation: 'landscape',
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(grossComponentPayHead, otherEarningPayHead, deductionPayHeadPayHead, payrollStatementData),

            styles: {
                header: {
                    fontSize: 24,
                }
            },

            defaultStyle: {
                color: 'black',
                fontSize: 8,
                font: 'SulaimanLipi'
            },

            info: {
                title: 'Payroll',
            }
        }

        pushIntoTable(doc, grossComponentPayHead, otherEarningPayHead, deductionPayHeadPayHead, payrollData, summaryData)

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getContent = (grossComponentPayHead, otherEarningPayHead, deductionPayHeadPayHead, payrollStatementData) => {
        return [
            {
                text:  'Payroll' + '(' + payrollStatementData.payroll_start_date + ' to ' + payrollStatementData.payroll_end_date + ')',
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 10],
                bold: true,
                color: 'black',
                fontSize: 12,
                decoration: 'underline'
            },

            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    body: [],
                    widths: getTableWidth(grossComponentPayHead, otherEarningPayHead, deductionPayHeadPayHead)
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
                }
            },
        ]
    }

    const pushIntoTable = (doc, grossComponentPayHead, otherEarningPayHead, deductionPayHeadPayHead, payrollData, summaryData) => {
        const tableItems = payrollData;
        const tableHeader = getTableHeader(grossComponentPayHead, otherEarningPayHead, deductionPayHeadPayHead);
        doc.content[1].table.body.push(tableHeader);

        tableItems.forEach((item) => {
            const rowData = getRowData(item, grossComponentPayHead, otherEarningPayHead, deductionPayHeadPayHead);
            return doc.content[1].table.body.push(rowData);
        });

        const getLastRow = getTotal(summaryData, grossComponentPayHead, otherEarningPayHead, deductionPayHeadPayHead)
        doc.content[1].table.body.push(getLastRow);
    }

    const getTableWidth = (grossComponentPayHead = [], otherEarningPayHead = [], deductionPayHeadPayHead = []) => {
        const dynamicColumns =
            grossComponentPayHead.length + 1 +
            otherEarningPayHead.length + 1 +
            deductionPayHeadPayHead.length + 2;

        const width = ['10%', '10%'];
        const remainingPercentage = 80;
        const individualWidth = (remainingPercentage / dynamicColumns) + '%';

        for (let i = 0; i < dynamicColumns; i++) {
            width.push(individualWidth);
        }

        return width;
    };

    const getTableHeader = (grossComponentPayHead = [], otherEarningPayHead = [], deductionPayHeadPayHead = []) => {
        const tableHeader = [
            { text: 'Employee ID' },
            { text: 'Employee Name' },
            ...grossComponentPayHead.map(item => ({ text: item.name })),
            { text: 'Gross Salary' },
            ...otherEarningPayHead.map(item => ({ text: item.name })),
            { text: 'Total Earning' },
            ...deductionPayHeadPayHead.map(item => ({ text: item.name })),
            { text: 'Total Deduction' },
            { text: 'Net' },
        ];
        return tableHeader;
    };

    const getRowData = (item = {}, grossComponentPayHead = [], otherEarningPayHead = [], deductionPayHeadPayHead = []) => {
        const tableRow = [
            { text: item.serial_no },
            { text: item.name },
            ...grossComponentPayHead.map(gh => ({
                text: commaFormat(item.gross_earnings[gh.id] || 0),
                alignment: 'right'
            })),
            { text: commaFormat(item.gross || 0), alignment: 'right' },
            ...otherEarningPayHead.map(oh => ({
                text: commaFormat(item.other_earnings[oh.id] || 0),
                alignment: 'right'
            })),
            { text: commaFormat(item.total_earning || 0), alignment: 'right' },
            ...deductionPayHeadPayHead.map(dh => ({
                text: commaFormat(item.deductions[dh.id] || 0),
                alignment: 'right'
            })),
            { text: commaFormat(item.total_deduction || 0), alignment: 'right' },
            { text: commaFormat(item.total || 0), alignment: 'right' },
        ];

        return tableRow;
    };

    const getTotal = (summaryData = {}, grossComponentPayHead = [], otherEarningPayHead = [], deductionPayHeadPayHead = []) => {
        const tableRow = [
            { text: "Total", colSpan: 2 },
            '',
            ...grossComponentPayHead.map(gh => ({
                text: commaFormat(summaryData.gross_earnings[gh.id] || 0),
                alignment: 'right'
            })),
            { text: commaFormat(summaryData.total_gross || 0), alignment: 'right' },
            ...otherEarningPayHead.map(oh => ({
                text: commaFormat(summaryData.other_earnings[oh.id] || 0),
                alignment: 'right'
            })),
            { text: commaFormat(summaryData.total_earning || 0), alignment: 'right' },
            ...deductionPayHeadPayHead.map(dh => ({
                text: commaFormat(summaryData.deductions[dh.id] || 0),
                alignment: 'right'
            })),
            { text: commaFormat(summaryData.total_deduction || 0), alignment: 'right' },
            { text: commaFormat(summaryData.total_net_payable || 0), alignment: 'right' },
        ];

        return tableRow;
    };

    return {
        exportToPDF
    }

}

export default pdfPrinter;